'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import IncentivesIndividualTemplateStyle from './style';
const FreeEconomicZones = dynamic(() => import('../components/FreeEconomicZones'));
const StateSupportProgram = dynamic(() => import('../components/StateSupportProgram'));
const TaxAndCustomsIncentives = dynamic(() => import('../components/TaxAndCustomsIncentives'));

const IncentivesIndividualTemplate = ({ data }) => {
	const { type } = data;

	return (
		<IncentivesIndividualTemplateStyle>
			{type === 'tax-and-customs-incentive-page' && <TaxAndCustomsIncentives pageData={data} />}
			{type === 'incentive-category-page' && <StateSupportProgram pageData={data} />}
			{type === 'free-economic-zone-page' && <FreeEconomicZones pageData={data} />}
		</IncentivesIndividualTemplateStyle>
	);
};

export default IncentivesIndividualTemplate;
